import type { IconSvgObject } from './types';

const FolderHeartIcon: IconSvgObject = [
  ["path", { d: "M8 6.49446H12.0179M12.0179 6.49446H20C21.1046 6.49446 22 7.38989 22 8.49446V10.5M12.0179 6.49446L9.60016 3.29437C9.22218 2.79407 8.63144 2.5 8.0044 2.5H4C2.89543 2.5 2 3.39543 2 4.5V18.5C2 19.6046 2.89543 20.5 4 20.5H11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 21.5C18 21.5 14 19.0294 14 16.6389C14 15.4576 14.8421 14.5 16 14.5C16.6 14.5 17.2 14.7059 18 15.5294C18.8 14.7059 19.4 14.5 20 14.5C21.1579 14.5 22 15.4576 22 16.6389C22 19.0294 18 21.5 18 21.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FolderHeartIcon;
